export const PROCESS_ID_SET = 'at/licenses/purchase/PROCESS_ID_SET'
export const PURCHASE_INFO_SET = 'at/licenses/purchase/PURCHASE_INFO_SET'
export const PURCHASE_STEP_NUMBER_SET = 'at/licenses/purchase/PURCHASE_STEP_NUMBER_SET'
export const PURCHASE_STRATEGY_TYPE_SET = 'at/licenses/purchase/PURCHASE_STRATEGY_TYPE_SET'
export const COMPANY_INFO_SET = 'at/licenses/purchase/COMPANY_INFO_SET'
export const INITIAL_HOSTING_ZONE_SET = 'at/licenses/purchase/INITIAL_HOSTING_ZONE_SET'
export const HOSTING_ZONE_SET = 'at/licenses/purchase/HOSTING_ZONE_SET'
export const LOCKED_ZONE_SET = 'at/licenses/purchase/LOCKED_ZONE_SET'
export const CONTEXT_SET = 'at/licenses/purchase/CONTEXT_SET'
export const CONTEXT_IN_USE_SET = 'at/licenses/purchase/CONTEXT_IN_USE_SET'
export const CONTEXT_INVALID = 'at/licenses/purchase/CONTEXT_INVALID'
export const CONTEXT_CHECKING_STATUS_SET = 'at/licenses/purchase/CONTEXT_CHECKING_STATUS_SET'
export const PROMO_EDITOR_MODE_SET = 'at/licenses/purchase/PROMO_EDITOR_MODE_SET'
export const PROMO_CODE_SET = 'at/licenses/purchase/PROMO_CODE_SET'
export const PROMO_INVALID_SET = 'at/licenses/purchase/PROMO_INVALID_SET'
export const PRICES_SET = 'at/licenses/purchase/PRICES_SET'
export const PAYMENT_METHOD_SET = 'at/licenses/purchase/PAYMENT_METHOD_SET'
export const AGREEMENTS_CONFIRMED_SET = 'at/licenses/purchase/AGREEMENTS_CONFIRMED_SET'
export const TRANSFER_HOSTING_ZONE_PROCESSING_SET = 'at/licenses/purchase/TRANSFER_HOSTING_ZONE_PROCESSING_SET'
export const DOCUMENT_URLS_SET = 'at/licenses/purchase/DOCUMENT_URLS_SET'
export const PURCHASE_STATE_RESET = 'at/licenses/purchase/PURCHASE_STATE_RESET'
export const LOADING_START = 'at/licenses/purchase/LOADING_START'
export const LOADING_FINISH = 'at/licenses/purchase/LOADING_FINISH'
export const VAT_NUMBER_SET = 'at/licenses/purchase/VAT_NUMBER_SET'
export const PO_NUMBER_SET = 'at/licenses/purchase/PO_NUMBER_SET'



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/actionTypes.js